import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const url = window.location.origin
const options = url.indexOf('.') > 0 ? {
  domain: url.slice(url.indexOf('.'))
} : {}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey, options)
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js